export default __webpack_public_path__ + "static/media/logo-ticketing.426f8c33.png";